/// <reference path="../_all.ts" />

module blog {

  BlogEntryDirective.$inject = ['blogService', 'pageMetaService'];

  export function BlogEntryDirective(
    blogService: IBlogService,
    pageMetaService: navigation.IPageMetaService
  ): ng.IDirective {

    return {
      restrict: "AE",
      scope: {
        entry: "="
      },
      templateUrl: "blog/BlogEntryDirective",
      transclude: true,
      link: function (scope: IBlogEntryDirective, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        scope.meta = pageMetaService.getPageMeta;

        scope.getEntryUrl = function (entry: editor.Content): string {
          if (entry.ContentMeta.URL) {            
            return pglob.RouteData.CurrentLanguage.hlPrefix + "/News/" + entry.ContentMeta.URL;
          } else {
            return entry.ContentMeta.RoutedURL
          }
        }

        scope.getImgSrc = function (entry: editor.Content): string {
          if (entry.ContentMeta.Image) {
            return "/svc/blogressource.axd?id=" + entry.ContentFilter.ContentId + "&type=1&lang=" + pglob.RouteData.CurrentLanguage.hl;
          } else {
            return "";
          }
        }

        scope.getAttachmentLink = function (entry: editor.Content): string {
          if (entry.ContentMeta.Attachment) {
            return "/svc/blogressource.axd?id=" + entry.ContentFilter.ContentId + "&type=2&lang=" + pglob.RouteData.CurrentLanguage.hl;
          } else {
            return "";
          }
        }

        scope.getGAPath = function (entry: editor.Content): string {
          var filename = entry.ContentMeta.RoutedURL;
          return "/Download/" + entry.ContentFilter.FilterString2 + "/" + scope.meta("hl") + "/" + filename;
        }

        scope.getAttachmentExtension = function(entry: editor.Content): string {
          if (entry.ContentMeta.Attachment) {
            return entry.ContentMeta.Attachment.substring(entry.ContentMeta.Attachment.indexOf(".") + 1)
          }
        }

        scope.getTagString = function (tags: editor.ContentTag[]): string {
          var tagNames = [];
          tags.forEach(function (element) {
            if (element.Name.indexOf("Product") != -1) {
              tagNames.push("<a href ng-click='$parent.vm.filterByTags($event, " + element + ")'>" + element.Names[pglob.RouteData.CurrentLanguage.hlFull] + "</a>");
            } else {
              tagNames.push(element.Name);
            }
          })

          return tagNames.join(", ");
        }

      }
    }
  }
}